import { h, render } from 'preact';
import Widget from './components/widget';
import store from './reducers'
import * as actions from './actions'
import {OrganizationActions, PatientActions, SessionActions, ConfigActions, AccountActions, PageActions, FilterActions} from './actions'
import {helpers} from './lib'
import dayjs from 'dayjs';
import events from 'actions/events'
import eventFlows from 'eventFlows'
let gravityURL = false;
module.exports = {
    init: (options = {})=>{
        options.widgetID = helpers.uuid()

        let _options = {
            organizationID: '',
            NILToken: '',
            version: '',
            type: '',
            date: '',
            appointmentTypeID: '',
            cost: options.cost,
            key: '',
            resetPassword: false
        }

        for(let key of Object.keys(options)){
            for(let _key of Object.keys(_options)){
                if(options[key] && _key.toLowerCase() == key.toLowerCase()){
                    _options[_key] = options[key]
                }
            }
        }

        
        let variableWhiteList = ['reason']
        for(let [key, value] of Object.entries(options)){
            let splitKey = key.split('.')
            if(variableWhiteList.includes(splitKey[0]) && splitKey.length == 2){
                if(value === 'true'){
                    value = true
                } else if (value === 'false'){
                    value = false
                }
                
                _options[`${splitKey[0]}`] = {
                    ...(_options[`${splitKey[0]}`] || {}),
                    [`${splitKey[1]}`]: value
                }
            }
        }

        console.log(_options)
        ConfigActions.set(_options)


        store.subscribe(()=>{
            
            const organization = (
                store.getState() || {}
            ).organization
            
            if(organization.id){                
                let _gravityURL
                if(_.get(organization,'gravity.staging')){
                    _gravityURL = 'https://assets.emergepay-sandbox.chargeitpro.com'
                }else{
                    _gravityURL = 'https://assets.emergepay.chargeitpro.com'
                }
    
                if(_gravityURL !== gravityURL){
                    gravityURL = _gravityURL
                    const gravity = document.createElement('script');
                    gravity.src = gravityURL+'/cip-hosted-fields.js';
                    gravity.type = 'application/javascript';
        
                    
                    document.body.appendChild(gravity);
                }
            }
        })

        return {
            root: null,
            store,
            actions,
            options: _options,
            events,
            render: function(target){
                target.innerHTML = ''
                
                eventFlows[this.options.type || 'defaultFlows']()

                if(this.options.organizationID){
                    let startingAt, endingAt
                    let filters = store.getState().filters || {}
                    let filterDate = dayjs(filters.startDate) || dayjs()
                    let weekStart = filterDate.clone().startOf('week')

                    startingAt = weekStart.format()
                    endingAt = weekStart.clone().endOf('week').format()

                    if(filterDate.day() == 6){
                        let nextWeek = filterDate.clone().add(1,'day').startOf('week')
                        endingAt = nextWeek.clone().endOf('week').format()
                    }

                    FilterActions.set({
                        ...store.getState().filters,
                        startDate: filterDate.format("MM/DD/YYYY")
                    })
                    
                    OrganizationActions.findByID(this.options.organizationID, startingAt, endingAt).then(()=>{
                        if(store.getState().page == 'receipt'){
                            PageActions.reset()
                        }
                        
                        if(((store.getState().session || {}).account || {}).id){
                            events.trigger('Account.accountDidSubmit', store.getState().session.account)
                            PatientActions.fetch({organizationID: this.options.organizationID}).then(()=>{
                                if((store.getState().organization.settings || {}).genericPatients && store.getState().session.accountID){
                                    let account = store.getState().session.account
                                    let accountMatch = false
                                    for(let patient of Object.values(store.getState().patients)){
                                        if(patient.firstName && patient.firstName.toLowerCase() == account.firstName.toLowerCase() && 
                                            patient.lastName && patient.lastName.toLowerCase() == account.lastName.toLowerCase()
                                        ){
                                            accountMatch = true
                                        }
                                    }
                                    if(!accountMatch){
                                        let patient = {
                                            firstName: account.firstName,
                                            lastName: account.lastName,
                                            id: `newPatient-${account.firstName.replace(/ /g, '-')}-${account.lastName.replace(/ /g, '-')}`,
                                        }
                                
                                        PatientActions.append(patient)
                                    }
                                }
                            })
                        }
                        if(this.options.NILToken && (!((store.getState().session || {}).account || {}).id)){
                            SessionActions.set({
                                accessToken: this.options.NILToken,
                                authenticating: true
                            })

                            AccountActions.fetchSession().then((res)=>{
                                if(store.getState().config.resetPassword){
                                    SessionActions.set({
                                        ...store.getState().session,
                                        resetPassword: true
                                    })
                                }
                                events.trigger('Organization.dataFetched')
                            })
                        } else {
                            if(!this.options.NILToken && (store.getState().session || {}).resetPassword){
                                SessionActions.set({})
                            }

                            events.trigger('Organization.dataFetched')
                        }
                        if((store.getState().organization.settings || {}).genericPatients){
                            ConfigActions.append({
                                genericPatients: true
                            })
                        }
                    });
                }

                this.root = render(<Widget />, target, target);
                return this;
            }
        }
    }
}

const script = document.createElement('script');
let baseURL = '';
let urlParams = window.location.href.split("?")[1]
let params = {}
if(urlParams){
    params = urlParams.split('&').reduce((acc,item)=>{
        acc[item.split('=')[0]] = item.split('=')[1]
        return acc
    },{})
}
if (params.version){
    baseURL = `https://${params.version}.appspot.com`
} else if(window.location.host.includes('localhost')){
    baseURL = 'http://localhost:8080'
} else {
    baseURL= 'https://soil.nextinline.io'
}
script.src = baseURL+'/js/repeating?version=' + (new Date()).getTime();
script.type = 'application/javascript';

document.body.appendChild(script);



// WEBPACK FOOTER //
// ./widget.js